import { createStyles } from '@mantine/core';
import { IconReload } from '@tabler/icons-react';
import useTranslation from 'next-translate/useTranslation';

import { ErrorScreen } from '~/domains/common/components/ErrorScreen/ErrorScreen';
import dt from '~/testing';

type ChannelErrorScreenProps = {
  isCurrentUserChannel?: boolean;
};

const useStyles = createStyles((theme) => ({
  icon: {
    color: theme.colors.gray[6],
  },
}));

function ChannelErrorScreen({ isCurrentUserChannel = false }: ChannelErrorScreenProps) {
  const { classes } = useStyles();

  const { t } = useTranslation('commissioner');

  return (
    <div data-test-id={dt.channel.channelErrorScreen}>
      <ErrorScreen
        title={t('common:pages.channelNotFound.title')}
        errorCode={<IconReload size={40} className={classes.icon} />}
        description={
          isCurrentUserChannel
            ? t('common:pages.channelNotFound.description.myChannel')
            : t('common:pages.channelNotFound.description.otherChannel')
        }
      />
    </div>
  );
}

export { ChannelErrorScreen };
